export default __webpack_public_path__ + "images/over-write.svg";